// extracted by mini-css-extract-plugin
export default {"image":"W6-z","loaded":"X6-z"};